module.exports = __webpack_public_path__ + "img/b2b01.998be0b5.png";